export default "__VITE_ASSET__8uHjsZRB__"